/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.UploadRelated";
        class DocActionUploadRelated extends DocActions.DocActionBaseClass {
            constructor(core, name) {
                super(core, name);
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionUploadRelated::constructor");
                this._label = this._core.Locale.getTranslation("STR_WPT_UPLOAD_RELATED");
            }
            actionAllowed(request) {
                this._log.info("DocActionUploadRelated.actionAllowed()");
                if (this._log.isTraceEnabled()) {
                    this._log.trace(`looking at type ${request.DocumentType.Name}`);
                }
                // Permission from service layer
                if (request.hasOwnProperty('DocumentType') && request.DocumentType) {
                    if (request.DocumentType.Name in this._core.OBHelper.DownloadDocumentTypeMap) {
                        let docType = this._core.OBHelper.DownloadDocumentTypeMap[request.DocumentType.Name];
                        if (!docType.Privileges.UploadRelated)
                            return false;
                    }
                }
                // Annoyingly, the home view is treated differently to every other one...
                if (this._core.Navigation.Details.getActiveLayoutName() == WPTNamespace.Navigation.HOME_VIEW_NAME) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("searching home view");
                    }
                    for (let i = 0; i < this._core.Widgets.StandardInstances.length; i++) {
                        if (this._core.Widgets.StandardInstances[i].Capabilities.indexOf('UploadRelated') > -1) {
                            // Force type - for our purposes anything with "UploadRelated" should expose the function we need so MDU casting will work
                            let mdu = this._core.Widgets.StandardInstances[i];
                            if (mdu.CanServiceDocType(request.DocumentType.Name))
                                return true;
                        }
                    }
                    for (let i = 0; i < this._core.Widgets.CustomInstances.length; i++) {
                        if (this._core.Widgets.CustomInstances[i].Capabilities.indexOf('UploadRelated') > -1) {
                            // Force type - for our purposes anything with "UploadRelated" should expose the function we need so MDU casting will work
                            let mdu = this._core.Widgets.CustomInstances[i];
                            if (mdu.CanServiceDocType(request.DocumentType.Name))
                                return true;
                        }
                    }
                }
                else {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`searching ${this._core.Navigation.Details.getActiveLayoutName()}`);
                    }
                    let instanceMap = this._core.Navigation.Details.getActiveLayout().getWidgetInstances();
                    for (let placeholder in instanceMap) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`checking ${placeholder}`);
                        }
                        if (instanceMap[placeholder].Capabilities.indexOf('UploadRelated') > -1) {
                            // Force type - for our purposes anything with "UploadRelated" should expose the function we need so MDU casting will work
                            let mdu = instanceMap[placeholder];
                            if (mdu.CanServiceDocType(request.DocumentType.Name))
                                return true;
                        }
                    }
                }
                return false;
            }
            execute(request) {
                this._log.info("DocActionUploadRelated.execute()");
                let navEvent = new WPTNamespace.Navigation.ActivationContext(null, WPTNamespace.Navigation.LayoutActivationType.RELATED_UPLOAD_REQUEST);
                navEvent.ActivationID = request.DocHandle;
                if (request.hasOwnProperty('Document') && (request.Document != null))
                    navEvent.PrimaryContext = request.Document;
                navEvent.Layout = this._core.Navigation.Details.getActiveLayoutName();
                this._core.Navigation.Details.requestActivation(navEvent);
            }
        }
        DocActions.DocActionUploadRelated = DocActionUploadRelated;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
